import { Wording } from '@/types';

export const MEDITATION_WORDING_SK: Wording = {
  components_header_media_content: 'Zvuky',
  components_header_media_1: 'Meditácie',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Sprievodcovia',
  components_header_text2: 'Blog',
  components_header_members: 'členov',
  hero_text: 'Kde sa meditácia stretáva s hviezdami',
  hero_button_text: 'Začnite svoju cestu dovnútra',
  components_ressources_section_title: 'ZDROJE',
  components_ressources_subheader_text: 'Nástroje pre vnútorný pokoj, uzemnenie a každodennú rovnováhu',
  components_ressources_span_text: 'Otvorte dvere vnútornému pokoju s našimi starostlivo vybranými meditáciami a sprievodcami. Nájdite jasnosť, znovu sa spojte so svojím dychom a zosúlaďte sa so svojím vnútorným rytmom – jeden moment za druhým.',
  components_ressources_card_1_title: 'Reflexia',
  components_ressources_card_1_text: 'Krátke meditácie a zvukové úvahy na vycentrovanie vašich myšlienok a prispôsobenie sa vášmu kozmickému rytmu.',
  components_ressources_card_2_title: 'Preskúmajte hlbiny',
  components_ressources_card_2_text: 'Vydajte sa za povrch s pohlcujúcim sprievodcom, ktorý spája meditáciu, astrológiu a sebaspytovanie pre trvalú transformáciu.',
  components_ressources_link: 'Zobraziť viac',
  components_notes_and_google_title_1: 'Duševné vedenie',
  components_notes_and_google_title_2: 'Všímavé rituály',
  components_notes_and_google_title_3: 'Vedené meditácie',
  components_review_google_text: 'Recenzie Google',
  media_content_section_title: 'ZVUKY',
  media_content_section_subheader_text: 'Naše meditácie',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Objavte viac',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: 'Kozmické znalosti pre každodenné zosúladenie',
  components_text1_span_text: 'Zosúlaďte sa s rytmami vesmíru: preskúmajte vybranú zbierku hĺbkových astrologických a meditatívnych sprievodcov navrhnutých tak, aby prebudili vnútornú jasnosť, prehĺbili sebauvedomenie a podporili vašu cestu oduševneného nebeského rastu.',
  components_text1_card_1_title: 'Otvorené do ticha',
  components_text1_card_1_text: 'Začnite svoju cestu so základnými sprievodcami meditácie a astrológie – ideálne pre tých, ktorí hľadajú vnútorný pokoj, vesmírne vzorce a osobný pohľad.',
  components_text1_card_3_title: 'Prepojenie mysle a tela',
  components_text1_card_3_text: 'Odhaľte hlbšie vrstvy svojho vnútorného sveta. Títo sprievodcovia sa pohybujú za povrchom, aby odhalili význam, emócie a vedomé vzorce, ktoré formujú vašu skúsenosť.',
  components_text1_card_2_title: 'Reflektujte a integrujte',
  components_text1_card_2_text: 'Od emocionálnych blokov po planetárne cykly – títo sprievodcovia ponúkajú nástroje na reflexiu, liečenie a transformáciu prostredníctvom vedomých rituálov a astrologickej múdrosti.',
  components_text1_link: 'Zobraziť všetkých sprievodcov',
  components_footer_text: 'Prebuďte sa vo vnútri: Vaša nehybnosť, vaša sila',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registračné číslo',
  components_footer_legal: 'Právne',
  components_footer_terms: 'Zmluvné podmienky',
  components_footer_privacy: 'Zásady ochrany osobných údajov',
  button_load_more: 'Načítať viac',
  page_media_1_content_hero_text: 'Meditácie',
  page_media_content_menu_antistress: 'Antistresová',
  page_media_content_menu_mindfulness: 'Všímavosť',
  page_media_content_menu_energyboost: 'Zvýšenie energie',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Sprievodcovia',
  page_text1_section_title: 'Sprievodcovia',
  page_text1_subheader_text: 'Naši sprievodcovia',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Ak chcete pokračovať, zadajte svoj e-mail',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Zadajte',
  components_login_success_text: 'Prihlásenie úspešné!',
  components_card_link_media_content: 'Počúvajte',
  components_card_link_text1_content: 'Zobraziť sprievodcu',
  components_card_link_text2_content: 'Preskúmajte',
  france: 'Francúzsko',
  cyprus: 'Cyprus',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditácia',
  page_media_content_menu_all: 'Všetky',
};